// extracted by mini-css-extract-plugin
export default {"authentication":"LoginForm_authentication__Ky4xs","cta":"LoginForm_cta__rmxv7"};